export default [
	'Artwork',
	'Discursive',
	'Teaching',
	// 'Artifact',
];
